module.exports = __webpack_public_path__ + "img/mall1.5e83428b.png";